import MyHutBoxDealTile from './MyHutBoxDealTile';

export default MyHutBoxDealTile;
